import { ProductPageContent } from './components/product-page-content';
import { ProductProvider } from './context/product-context';

export default function ProductPage() {
  return (
    <ProductProvider>
      <ProductPageContent />
    </ProductProvider>
  );
}
